module.exports = moment;


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 303
// module chunks = 7